(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["go-cart-tracking"] && !Shopify.designMode) return;
  try {
    function goNormalizeCart(cart, now = new Date().toISOString()) {
  const origin = 'https://www.groworganic.com';
  if (!cart || !Array.isArray(cart.items)) throw new Error('Missing full cart');
  const safeUrl = (value, product = false) => {
    if (!value) return '';
    try {
      const url = new URL(value, origin);
      if (url.protocol !== 'https:') return '';
      if (product && url.origin !== origin) return '';
      return url.href;
    } catch { return ''; }
  };
  let recoverable = true;
  const quantities = new Map();
  const lines = cart.items.map(item => {
    const id = String(item.variant_id ?? item.id ?? '');
    const quantity = Number(item.quantity);
    const price = Number(item.original_price ?? item.price);
    const linePrice = Number(item.original_line_price ?? item.line_price);
    if (!/^\d+$/.test(id) || !Number.isSafeInteger(Number(id)) || !Number.isSafeInteger(quantity) || quantity < 1) throw new Error('Invalid cart line');
    if (!Number.isFinite(price) || price < 0 || !Number.isFinite(linePrice) || linePrice < 0) throw new Error('Invalid cart price');
    if (item.selling_plan_allocation || item.parent_relationship || item.item_components?.length || Object.values(item.properties || {}).some(v => v !== null && String(v) !== '')) recoverable = false;
    quantities.set(id, (quantities.get(id) || 0) + quantity);
    const imageUrl = safeUrl(item.image || item.featured_image?.url);
    const productUrl = safeUrl(item.url, true);
    const handle = productUrl ? new URL(productUrl).pathname.match(/^\/products\/([^/]+)$/)?.[1] || '' : '';
    return {
      title: String(item.product_title || item.title || 'Your garden selection'),
      variant_title: item.variant_title === 'Default Title' ? '' : String(item.variant_title || ''),
      variant_id: id,
      product_id: String(item.product_id || ''),
      quantity,
      price: price / 100,
      line_price: linePrice / 100,
      product: {title: String(item.product_title || item.title || 'Your garden selection'), handle,
        images: imageUrl ? [{src: imageUrl}] : [], variant: {images: imageUrl ? [{src: imageUrl}] : []}},
      url: productUrl
    };
  });
  const itemCount = lines.reduce((sum, item) => sum + item.quantity, 0);
  if (Number(cart.item_count) !== itemCount) throw new Error('Incomplete cart snapshot');
  const recovery = lines.length && recoverable
    ? `${origin}/cart/${[...quantities].map(([id, qty]) => `${id}:${qty}`).join(',')}?storefront=true`
    : '';
  return {schema_version: 1, source: 'storefront', updated_at: now,
    currency: String(cart.currency || 'USD'), item_count: itemCount, line_count: lines.length,
    recoverable: Boolean(recovery), checkout_url: recovery, line_items: lines};
}


(function () {
  const element = document.getElementById('go-cart-tracking');
  if (!element || element.dataset.loaded === 'true') return;
  element.dataset.loaded = 'true';
  const qa = false;
  const active = element.dataset.mode === 'production';
  if (!active) return;
  let latest;
  let timer;
  let generation = 0;
  let observedSignature = '';
  let sentSignature = '';
  let sending = false;
  let pendingSnapshot;
  let hooked = false;
  let panel;
  const signature = snapshot => JSON.stringify({...snapshot, updated_at: ''});
  const status = text => { if (panel) panel.querySelector('[data-go-status]').textContent = text; };
  const sendStatus = text => { if (panel) panel.querySelector('[data-go-send-status]').textContent = text; };
  const limited = (promise, name) => new Promise((resolve, reject) => {
    const timeout = setTimeout(() => reject(new Error(`${name} timed out`)), 10000);
    Promise.resolve(promise).then(value => { clearTimeout(timeout); resolve(value); }, error => { clearTimeout(timeout); reject(error); });
  });
  const allowed = () => {
    const privacy = window.Shopify?.customerPrivacy;
    return Boolean(privacy?.analyticsProcessingAllowed() && privacy?.marketingAllowed());
  };
  const api = () => window.klaviyo;
    async function send(snapshot) {
    if (sending) {
      if (!qa) pendingSnapshot = snapshot;
      sendStatus('A snapshot is already being sent.');
      return;
    }
    if (!snapshot || !allowed() || !api()) { sendStatus('Waiting for tracking consent or Klaviyo.'); return; }
    const sig = signature(snapshot);
    if (sig === sentSignature) { sendStatus('Duplicate snapshot skipped.'); return; }
    sending = true;
    try {
      sendStatus('Checking Klaviyo account.');
      if (await limited(api().account(), 'Account check') !== 'WUmWyJ') throw new Error('Wrong Klaviyo account');
      if (!await limited(api().isIdentified(), 'Identity check')) { sendStatus('Waiting for a known Klaviyo profile.'); return; }
      if (!allowed()) { sendStatus('Tracking consent is unavailable.'); return; }
      sendStatus('Saving the complete-cart profile snapshot.');
      await limited(api().identify({GO_StorefrontCart: snapshot,
        GO_StorefrontCartHasItems: snapshot.item_count > 0,
        GO_StorefrontCartRecoverable: snapshot.recoverable,
        GO_StorefrontCartUpdatedAt: snapshot.updated_at,
        GO_CartCurrent: snapshot, GO_CartHasItems: snapshot.item_count > 0,
        GO_CartRecoverable: snapshot.recoverable, GO_CartUpdatedAt: snapshot.updated_at}), 'Profile snapshot');
      if (!allowed()) return;
      sendStatus('Sending the complete-cart event.');
      const accepted = await limited(api().track('GO Cart Ready', {
        $event_id: crypto.randomUUID(), $value: snapshot.line_items.reduce((n, x) => n + x.line_price, 0),
        $currency_code: snapshot.currency, Source: 'storefront', SchemaVersion: 1,
        IsTest: qa, ItemCount: snapshot.item_count, LineCount: snapshot.line_items.length, Recoverable: snapshot.recoverable,
        extra: snapshot
      }), 'Event tracking');
      if (accepted === false) throw new Error('Snapshot not accepted');
      sentSignature = sig;
      sendStatus(`Snapshot accepted: ${snapshot.line_items.length} lines, ${snapshot.item_count} units.`);
    } catch (error) { sendStatus(`Snapshot not sent: ${error.message}`); }
    finally {
      sending = false;
      const pending = pendingSnapshot;
      pendingSnapshot = undefined;
      if (pending && signature(pending) !== sentSignature) await send(pending);
    }
  }
  async function refresh() {
    if (!qa && !allowed()) return;
    const request = ++generation;
    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(`${root}cart.js`, {credentials: 'same-origin', cache: 'no-store', headers: {Accept: 'application/json'}});
      if (!response.ok) throw new Error('Cart unavailable');
      const snapshot = goNormalizeCart(await response.json());
      if (request !== generation) return;
      const sig = signature(snapshot);
      if (sig === observedSignature && latest) snapshot.updated_at = latest.updated_at;
      observedSignature = sig;
      latest = snapshot;
      if (panel) {
        panel.querySelector('pre').textContent = JSON.stringify(snapshot, null, 2);
        const recovery = panel.querySelector('[data-go-recovery]');
        recovery.hidden = !snapshot.recoverable;
        recovery.href = snapshot.checkout_url || '#';
        status(`Captured ${snapshot.line_items.length} lines, ${snapshot.item_count} units. ${snapshot.recoverable ? 'Cart recovery available.' : 'Cart-only sending disabled for this cart.'}`);
      }
      if (!qa) await send(snapshot);
    } catch (error) { status(`Capture unavailable: ${error.message}`); }
  }
  function schedule() { clearTimeout(timer); timer = setTimeout(refresh, 700); }
  function hookTheme() {
    if (hooked) return;
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, schedule);
      hooked = true;
    }
  }
  document.addEventListener('cartChange', schedule);
  document.addEventListener('visitorConsentCollected', schedule);
  window.addEventListener('klaviyoForms', event => { if (event.detail?.type === 'submit') { sentSignature = ''; schedule(); } });
  window.addEventListener('pageshow', schedule);
  document.addEventListener('visibilitychange', () => { if (!document.hidden) schedule(); });
  if (typeof PerformanceObserver !== 'undefined') {
    const observer = new PerformanceObserver(list => {
      if (list.getEntries().some(entry => {
        try { const url = new URL(entry.name); return url.origin === location.origin && /\/cart\/(add|change|update|clear)(\.js)?$/.test(url.pathname); } catch { return false; }
      })) schedule();
    });
    observer.observe({entryTypes: ['resource']});
  }
  hookTheme();
  document.addEventListener('DOMContentLoaded', () => { hookTheme(); schedule(); }, {once: true});
  window.addEventListener('load', () => { hookTheme(); schedule(); }, {once: true});
  if (!window.Shopify?.customerPrivacy && window.Shopify?.loadFeatures) {
    window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}], error => { if (!error) schedule(); });
  }
  schedule();
}());
  } catch(e) { console.error(e); }
})();

})();
